//引入axios进行封装
import axios from "axios";
//引入进度条(start：进度条开始  done：进度条结束)
import nprogress from "nprogress";
//引入进度条的样式
import "nprogress/nprogress.css";

const requests = axios.create({
  /*配置对象*/
  //基础路径，发送请求的时候，路径中会自动添加api
  // baseURL:"/apiasfdf",
  //请求超时的时间
  timeout: 120000,
});

//请求拦截器：在发请求之前，请求拦截器可以检测得到
requests.interceptors.request.use((config) => {
  //进度条开始
  nprogress.start();
  // if(!(config.url.indexOf("/login/value/"))){
  // }
  //config:配置对象，对象里面有一个属性很重要，headers请求头
  return config;
})

//响应拦截器：在服务器的时间回来后可以检测到，然后进行处理
requests.interceptors.response.use((res) => {
  //进度条结束
  nprogress.done();
  //成功的回调函数
  return res.data;
}, (error) => {
  //进度条结束
  nprogress.done();
  //失败的回调函数
  return Promise.reject(error);
});

//暴露axios
export default requests;



// WEBPACK FOOTER //
// ./src/api/request.js